import { Modal } from 'antd';
import CustomButton from '../../../../../../../../v2-components/Antd/Button';
import './style.scss'; // Asegúrate de tener el estilo adecuado

const QuotationFailModal = ({ visible, onCancel, onDeleteCart }) => {
  return (
    <Modal
      title="Ups!"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <CustomButton key="accept" className="ph-btn ph-btn--accept" onClick={() => onCancel(true)}>
          Cancelar
        </CustomButton>,
        <CustomButton key="cancel" className="ph-btn ph-btn--cancel" onClick={onDeleteCart}>
          <p style={{marginLeft: '-2px'}}>Borrar bolsa</p>
        </CustomButton>,
      ]}
      className="delivery-modal" 
    >
      <div>
        <p>La cotización que estás intentando pagar ha sido cancelada, borra la bolsa para avanzar.</p>
      </div>
    </Modal>
  );
};

export default QuotationFailModal;
